<script lang="ts" setup>
import AppMarkdown from 'theme/components/atoms/AppMarkdown.vue';
import SimplePageContainer from 'theme/components/molecules/SimplePageContainer.vue';
import SimplePageHeading from 'theme/components/molecules/SimplePageHeading.vue';

const md = `
|  | 契約締結前交付書面（※） 最新版 | 業務及び財産の状況に関する説明書 | 委託元金融機関に対するご意見・苦情の申立てについて
| --- | --- | --- | --- |
| 楽天証券株式会社 | https://public-docs.400f.jp/contracts/rakuten/400f_maeshomen_rakuten_202411.pdf | 同社HPの ホーム＞楽天証券について＞開示情報 よりご確認ください<br>https://www.rakuten-sec.co.jp/web/company/disclosure/ | 楽天証券カスタマーサービスセンター<br> フリーダイヤル：0120-885-696<br> 携帯電話から：03-6739-3356（通話料有料）<br> 受付時間：月曜日〜金曜日 9時00分〜17時00分（祝日を除く） |
| 株式会社SBI証券 | https://public-docs.400f.jp/contracts/sbi/400f_maeshomen_sbi_202411.pdf | 同社HPの ホーム＞会社情報＞開示情報 よりご確認ください<br>https://www.sbisec.co.jp/ETGate/?OutSide=on&_ControlID=WPLETmgR001Control&_DataStoreID=DSWPLETmgR001Control&burl=search_home&cat1=home&cat2=corporate&dir=corporate%2F&file=home_kaiji.html&getFlg=on | [同社HPをご確認ください（SBI証券のページに移動します）](https://www.sbisec.co.jp/ETGate/WPLETmgR001Control?OutSide=on&getFlg=on&burl=search_home&cat1=home&cat2=none&dir=info&file=home_adr.html) |
| マネックス証券株式会社 | https://public-docs.400f.jp/contracts/monex/400f_maeshomen_monex_202411.pdf | 同社HPの ホーム＞会社情報＞開示情報 よりご確認ください<br>https://info.monex.co.jp/company/disclosure/index.html | マネックス証券株式会社 お客様専用ダイヤル<br>フリーダイヤル: 0120-430-283<br>携帯電話（有料）: 03-6737-1667<br>受付時間: 月曜日〜金曜日 8時00分〜17時00分（祝日を除く） |
| ニッセイアセットマネジメント株式会社 | https://public-docs.400f.jp/contracts/nissei_asset_management/400f_maeshomen_nissei_asset_management_202411.pdf | 同社営業所に備え置いております | ニッセイアセットマネジメント株式会社<br>本店：03-5533-4000（代表）<br>大阪営業所：06-6204-0201（代表）<br>受付時間：月曜日～金曜日 9時00分～17時00分（祝日を除く）|
| 株式会社スマートプラス | https://public-docs.400f.jp/contracts/smart_plus/400f_maeshomen_smart_plus_202411.pdf | 同社HPの ホーム＞企業情報＞開示情報 よりご確認ください。<br>https://smartplus-sec.com/company/disclosure/ | 株式会社スマートプラス コンプライアンス部<br>050-1745-7336<br>受付時間：月曜日～金曜日 8時30分～17時30分（祝日、年末年始を除く）<br>※下記メールアドレスでもお問い合わせを受け付けております。<br>電子メール：smartplus_compliance@smartplus-sec.com |

※当該契約締結前交付書面は、当社が作成しお客様に交付する内容を指します。委託元金融機関から交付される書面は、各委託元金融機関にご確認ください。

## 指定紛争解決機関について

委託元金融機関である証券会社の指定紛争解決機関は、証券・金融商品あっせん相談センター（ADR FINMAC）です。FINMACに関する資料は、[こちら](https://www.finmac.or.jp/wp/wp-content/uploads/2020/09/A4leaf_2008.pdf)をご参照ください。
※金融サービス仲介業者である当社の指定紛争解決機関は東京三弁護士会です。
`;
</script>

<template>
  <SimplePageContainer :class="$style.container">
    <SimplePageHeading
      :class="$style.container__title"
      title="委託元金融機関に関するご案内"
    />
    <p :class="$style.container__description">
      各委託元金融機関に関する情報を掲示しています。
    </p>
    <AppMarkdown :class="$style.container__body" :body="md" />
  </SimplePageContainer>
</template>

<style lang="scss" module>
.container {
  &__description {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__body {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}
</style>
